const $ = jQuery

export default function LoadMore() {
  const EMP_FILTERS = document.querySelectorAll('.mtt-employee-filter')
  if (EMP_FILTERS.length > 0) {
    for (let i = 0; i < EMP_FILTERS.length; i++) {
      const loadMore = new LoadMoreEmployees(EMP_FILTERS[i])
      loadMore.init()
    }
  }
}

class LoadMoreEmployees {
  constructor (container) {
    this.CONTAINER = container
    this.LOAD_MORE_BUTTON = this.CONTAINER.querySelector('.load-more')
    this.LOAD_MORE_TARGET = this.CONTAINER.querySelector('.load-more-target')
    this.LOADER = this.CONTAINER.querySelector('.mtt-employee-filter__loader')
    this.DEPARTMENTSELECT = this.CONTAINER.querySelector('select[name="employee-department-select"]')
    this.COMPANYSELECT = this.CONTAINER.querySelector('select[name="employee-company-select"]')
    this.FILTER_ITEMS = this.CONTAINER.querySelectorAll('.mtt-filter__item')

    this.data = {
      action: 'filter_employees',
      company: parseInt(this.CONTAINER.getAttribute('data-company')),
      department: 0
    }
  }

  init () {
    if (this.LOAD_MORE_BUTTON && this.LOAD_MORE_TARGET) {

      // setup data
      this.data.current = parseInt(this.LOAD_MORE_BUTTON.getAttribute('data-current'))
      this.data.total = parseInt(this.LOAD_MORE_BUTTON.getAttribute('data-total'))

      // add events
      this.loadMoreEvent()
      this.setupEventListeners()
    }
  }

  loadMoreEvent () {
    this.LOAD_MORE_BUTTON.addEventListener('click', () => {

      // update current
      this.data.current++

      // fetch posts
      this.doAjax()
    })
  }

  setupEventListeners() {
    if (this.DEPARTMENTSELECT) {
      this.DEPARTMENTSELECT.addEventListener('change', () => {
        const ITEM = this.DEPARTMENTSELECT.selectedOptions[0]
        this.setupData()
        this.doAjax(true)
        this.setActiveItem(ITEM)
      })
    }

    if (this.COMPANYSELECT) {
      this.COMPANYSELECT.addEventListener('change', () => {
        const ITEM = this.COMPANYSELECT.selectedOptions[0]
        this.setupData()
        this.doAjax(true)
        this.setActiveItem(ITEM)
      })
    }
  }

  setupData() {
    this.data.current = 1
    if (this.DEPARTMENTSELECT) {
      this.data.department = parseInt(this.DEPARTMENTSELECT.selectedOptions[0].value)
    }

    if (this.COMPANYSELECT) {
      this.data.company = parseInt(this.COMPANYSELECT.selectedOptions[0].value)
    }
  }

  setActiveItem (ITEM) {
    for (let i = 0; i < this.FILTER_ITEMS.length; i++) {
      this.FILTER_ITEMS[i].classList.remove('mtt-filter__item--active')
    }
    ITEM.classList.add('mtt-filter__item--active')
  }

  checkLoadMoreButton () {
    if (this.data.current === this.data.total) {
      this.LOAD_MORE_BUTTON.classList.add('hide')
    } else {
      this.LOAD_MORE_BUTTON.classList.remove('hide')
    }
  }

  doAjax (replace = false) {
    this.showLoader()
    $.post(main_theme_objects.ajax_url, this.data, (response) => {
      if (response !== 0) {
        if (replace) {
          this.LOAD_MORE_TARGET.innerHTML = response.markup
        } else {
          this.LOAD_MORE_TARGET.innerHTML += response.markup
        }

        this.data.total = parseInt(response.total)
        this.checkLoadMoreButton()
        this.hideLoader()
      }
    })
  }

  showLoader ()  {
    this.LOADER && this.LOADER.classList.add('loader--show')
  }

  hideLoader ()  {
    this.LOADER && this.LOADER.classList.remove('loader--show')
  }
}